<template>
  <div class="pt-4 text-center">
    <h1 class="blocked__title">Jesteś wyjątkowy</h1>
    <Icon class="blocked__image" icon="new-card" />
    <h2 class="blocked__subtitle">Twój kontrakt ma specjalne warunki.</h2>
    <p class="blocked__description">
      Aby złożyć zamówienie, skontaktuj się z nami pod numerem <a href="tel:225351414">22 535 14 14</a> lub pobierz szablon składania zamówienia.
    </p>
    <a
      href="https://www.pluxee.pl/panel-klienta-b2b/formularze-zamowien/"
      rel="external nofollow"
      target="_blank"
      class="btn btn-primary my-5"
    >Pobierz szablon</a>
  </div>
</template>

<script>
import Icon from '@/components/Icon.vue';

export default {
  name: 'BlockedOrder',
  components: {
    Icon,
  },
};
</script>
